import { ca } from '@cian/analytics';

import { IBrokerAnalyticsUser } from '../../../types/newbuildingBroker';

export const trackFallbackModalOpen = (user: IBrokerAnalyticsUser) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Show',
    label: 'BrokerDealPopUpFail',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        is_link: false,
      },
    },
    user,
    useLastProducts: true,
  });
};
